<template>
  <div class="container">
    <div class="head-box">
      <img src="../assets/logo2.png" class="logo" />
      <div class="switch-btn" v-on:click="switchLang">
        <img src="../assets/en.png" class="switch-img" v-show="isEnLang"></img>
        <img src="../assets/ch.png" class="switch-img" v-show="isChLang"></img></div>
    </div>
    <div class="row">
      <p class="label">{{langConfig[langKey].name}}<span class="span-1">*</span></p>
      <input v-model="name"  />
    </div>
    <div class="row">
      <p class="label">{{langConfig[langKey].nationality}}<span  class="span-1">*</span></p>
      <input v-model="nationality" />
    </div>
    <div class="row">
      <p class="label">{{langConfig[langKey].organization}}<span  class="span-1">*</span></p>
      <input v-model="organization"  />
    </div>
    <div class="row">
      <p class="label">{{langConfig[langKey].position}}<span  class="span-1">*</span></p>
      <input v-model="position"/>
    </div>
    <div class="row">
      <p class="label">{{langConfig[langKey].email}}<span  class="span-1">*</span></p>
      <input v-model="email"  />
    </div>
    <div class="row">
      <p class="label">{{langConfig[langKey].phone}}<span  class="span-1">*</span></p>
      <input
        v-model="phone"
        oninput="value = value.replace(/[^0-9]/g,'');"
        type="text"
        maxlength="11"
      />
    </div>
    <div class="row">
      <p class="label">{{langConfig[langKey].intentedProduct}}<span  class="span-1">*</span></p>
      <textarea rows="3" v-model="intented" />
    </div>
    <div class="row">
      <p class="label">{{langConfig[langKey].remark}}</p>
      <textarea rows="3" v-model="remark"  />
    </div>
    <div class="footer">
      <img class="footer-bg" src="../assets/foot_bg.png" />
    </div>

    <div class="btn-box">
      <div class="btn" v-on:click="onCommit">{{langConfig[langKey].commit}}</div>
    </div>
  </div>
</template>

<script>
import api from "../utils/api";
export default {
  name: "CollectInfo",
  data() {
    return {
      name: "",
      nationality: "",
      organization: "",
      position: "",
      email: "",
      phone: "",
      intented: "",
      remark: "",
      langKey: "en",
      langConfig: {
        en: {
          lang:"english",
          name: "Name",
          nationality: "Nationality",
          organization: "Organization",
          position: "Position",
          email: "E-mail",
          phone: "Phone",
          intentedProduct: "Products",
          remark: "Remark",
          commit:"submit",
          empty_tip_name:"name cannot be empty",
          empty_tip_nationality:"nationality cannot be empty",
          empty_tip_organization:"organization cannot be empty",
          empty_tip_position:"position cannot be empty",
          empty_tip_email:"email cannot be empty",
          empty_tip_email_right:"please enter the correct email",
          empty_tip_phone:"mobile number cannot be empty",
          empty_tip_phone_right:"please enter the correct mobile number",
          empty_tip_intented:"intented product cannot be empty",
          commit_success:"commit success",
        },
        ch: {
          lang:"中文",
          name: "姓名",
          nationality: "国籍",
          organization: "单位",
          position: "职务",
          email: "电子邮箱",
          phone: "电话",
          intentedProduct: "意向产品",
          remark: "备注",
          commit:"提交",
          empty_tip_name:"姓名不能为空",
          empty_tip_nationality:"国籍不能为空",
          empty_tip_organization:"单位不能为空",
          empty_tip_position:"职位不能为空",
          empty_tip_email:"电子邮箱不能为空",
          empty_tip_email_right:"请输入正确的邮箱",
          empty_tip_phone:"手机号不能为空",
          empty_tip_phone_right:"请输入正确的手机号",
          empty_tip_intented:"意向产品不能为空",
          commit_success:"登记成功",
        }
      }
    };
  },
  computed:{
     getLangImg(){
       if(this.langKey=="en"){
         return "../assets/en.png"
       }else{
         return "../assets/ch.png"
       }
     },
      isEnLang(){
        return this.langKey=="en"
      },
       isChLang(){
        return this.langKey=="ch"
      }
  },
  methods: {
    onCommit(event) {
      if (this.name == "") {   
        this.$toast(this.langConfig[this.langKey].empty_tip_name, "success", 2000);
        return;
      }
      if (this.nationality == "") {
        this.$toast(this.langConfig[this.langKey].empty_tip_nationality, "success", 2000);
        return;
      }
      if (this.organization == "") {
        this.$toast(this.langConfig[this.langKey].empty_tip_organization, "success", 2000);
        return;
      }
      if (this.position == "") {
        this.$toast(this.langConfig[this.langKey].empty_tip_position, "success", 2000);
        return;
      }
      if (this.email == "") {
        this.$toast(this.langConfig[this.langKey].empty_tip_email, "success", 2000);
        return;
      }
      let reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
      if (!this.email.match(reg)) {
        this.$toast(this.langConfig[this.langKey].empty_tip_email_right, "success", 2000);
        return;
      }
      if (this.phone == "") {
        this.$toast(this.langConfig[this.langKey].empty_tip_phone, "success", 2000);
        return;
      }
      let reg2 = /^[1][3,4,5,7,8,9][0-9]{9}$/;
      if (!this.phone.match(reg2)) {
        this.$toast(this.langConfig[this.langKey].empty_tip_phone_right, "success", 2000);
        return;
      }

      if (this.intented == "") {
        this.$toast(this.langConfig[this.langKey].empty_tip_intented, "success", 2000);
        return;
      }
      const param = {
        email: this.email,
        intendedProducts: this.intented,
        name: this.name,
        nationality: this.nationality,
        organization: this.organization,
        position: this.position,
        remark: this.remark,
        telephoneNumber: this.phone
      };
      api.signIn(param).then(res => {
        this.$toast(this.langConfig[this.langKey].commit_success, "success", 2000);
        this.name = "";
        this.email = "";
        this.phone = "";
        this.nationality = "";
        this.intented = "";
        this.organization = "";
        this.position = "";
        this.remark = "";
        this.$router.push({
          path:"/SuccessPage",query:{
            lang:this.langKey
          }
        });
      });
    
    },
    switchLang(){
      if(this.langKey=="en"){
        this.langKey="ch"
      }else{
        this.langKey="en"
      }
    },
     
  }
};
</script>

<style>
.container {
  background-color: white;
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: 7.5rem 7.5rem;
}
.row {
  display: flex;
  flex-direction: row;
  align-content: center;
  z-index: 99;
}
input {
  z-index: 88;
  margin-right: 0.3rem;
  margin-top: 10px;
  outline: none;
  border: 1px solid #999;
  border-radius: 3px;
  padding: 5px 7px;
  font-size: 0.3rem;
  background-color: transparent;
  color: #333;
  flex: 1;
}
input:focus {
  outline: none;
  border: 1px solid #4e63f2;
}

textarea {
  z-index: 88;
  margin-right: 0.3rem;
  margin-top: 10px;
  outline: none;
  border: 1px solid #999;
  border-radius: 3px;
  padding: 5px 7px;
  font-size: 0.3rem;
  background-color: transparent;
  color: #333;
  flex: 1;
}
textarea:focus {
  outline: none;
  border: 1px solid #4e63f2;
}

input::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #ccc;
  font-size: 0.25rem;
  font-weight: bolder;
  padding: 0.1rem;
}
input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #ccc;
  font-size: 0.25rem;
  padding: 0.1rem;
  font-weight: bolder;
}
input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #ccc;
  font-size: 0.25rem;
  font-weight: bolder;
  padding: 0.1rem;
}
input:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #ccc;
  font-size: 0.25rem;
  font-weight: bolder;
  padding: 0.1rem;
}

textarea::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #ccc;
  font-size: 0.25rem;
  font-weight: bolder;
  padding: 0.1rem;
}
textarea:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #ccc;
  font-size: 0.25rem;
  padding: 0.1rem;
  font-weight: bolder;
}
textarea::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #ccc;
  font-size: 0.25rem;
  font-weight: bolder;
  padding: 0.1rem;
}
textarea:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #ccc;
  font-size: 0.25rem;
  font-weight: bolder;
  padding: 0.1rem;
}
.title {
  font-size: 0.3rem;
  color: #000;
  margin-top: 0.3rem;
  margin-bottom: 0.3rem;
}
.label {
  width: 1.7rem;
  margin-left: 0.3rem;
  margin-right: 0.3rem;
  font-size: 0.3rem;
  text-align: left;
}
.span-1{
  color: red;
  font-size: 0.3rem;
  padding-top: 0.15rem;
}
.btn-box {
  margin-top: 0.3rem;
  display: flex;
  justify-content: center;
}
.btn {
  z-index: 88;
  margin-top: 0.6rem;
  width: 5rem;
  height: 0.8rem;
  line-height: 0.8rem;
  border-radius: 0.6rem;
  background-color: #1160f1;
  color: white;
}
.logo {
  width: 3.75rem;
  margin-top: 0.6rem;
  margin-bottom: 0.6rem;
}
.footer {
  position: fixed;
  bottom: 0;
}
.footer-bg {
  width: 7.5rem;
  height: 7.5rem;
}
.head-box{
  position: relative;
}
.switch-btn{
  z-index: 88;
  position: absolute;
  top: 0.3rem;
  right: 0.3rem; 
  width:0.4rem ;
  height: 0.4rem;
  /* border: 1px solid #999;
  padding: 0.15rem; */
  font-size: 0.3rem;
}
.switch-img{
   width:0.6rem ;
   height: 0.6rem;
}
</style>



// WEBPACK FOOTER //
// src/components/CollectInfo.vue